module.exports = __webpack_public_path__ + "img/menu-more.bef0f373.svg";